<template>
    <div v-viewer="viewerOptions" class="images column">
        <template v-for="(image, index) in images">
            <div class="image-gallery" :class="index >= 5 ? 'd-none image-item' : `image-item-${index +1}`"
                 >
                <img :src="image.file.path" :data-source="image.file.path" class="image" :key="image.file.path" :alt="image.file.name">
                <div class="caption"v-if="index === 4">
                    {{displayAvailableImages}}
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import LightBox from 'vue-image-lightbox';
    require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

    export default {
        name: "design-2021-profile-card-image-component",
        props: ['images'],
        components: {
            LightBox,
        },
        data () {
            return {
                viewerOptions: {
                    inline:     false,
                    button:     true,
                    navbar:     true,
                    title:      true,
                    toolbar:    true,
                    tooltip:    true,
                    movable:    true,
                    zoomable:   true,
                    rotatable:  true,
                    scalable:   false,
                    transition: true,
                    fullscreen: true,
                    keyboard:   true,
                    url: 'data-source'
                },
            }
        },
        computed: {
            displayAvailableImages() {
                return `${this.images.length - 5}+`
            },
        }
    }
</script>

<style scoped lang="scss">

    .image-gallery {
        img {
            width: 100%;
            border-radius: $border-radius-content;
        }

        .caption {
            position: absolute;
            top: calc(50% - 18px);
            left: calc(50% - 18px);
            font-size: 2rem;
            font-weight: $font-weight-bold;
            color: $white;
            text-shadow: 2px 2px $text-color;
        }

        &:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
            position: relative;
        }
    }

    .images.column {
        width: 100%;
    }


    @media (min-width: map-get($grid-breakpoints, 'lg')) {
        .column {
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            grid-gap: 0.1rem;
        }

        .image-gallery {
            border: 0;
            margin-bottom: 0;

            img {
                width: 100%;
                height: 100%;
                max-height: 350px;
                object-fit: cover;
                display: block;
            }

            .caption {
                position: absolute;
                font-size: 3rem;
                top: calc(50% - 28px);
                left: calc(50% - 28px);
            }
        }

        .image-item-1{
            grid-column: 1 / span 4;
            grid-row: 1 / span 2;

            &:last-child {
                grid-column: 1 / span 8;
                grid-row: 1 / span 3;
            }
        }

        .image-item-2:nth-child(2) {
            grid-column: 5 / span 4;
            grid-row: 1 / span 2;
        }

        .image-item-3{
            grid-column: 1 / span 4;
            grid-row: 3 / span 2;

            &:last-child {
                grid-column: 1 / span 8;
                grid-row: 3 / span 3;
            }
        }

        .image-item-4 {
            grid-column: 5 / span 4;
            grid-row: 3 / span 2;
        }

        .image-item-5 {
             grid-column: 1 / span 8;
             grid-row: 5 / span 4;
        }
    }

</style>
